// extracted by mini-css-extract-plugin
export var growableInput = "_3j-0";
export var tagContainer = "_3j-2";
export var textInput = "_3j-1";